import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired")({
  beforeLoad: () => {
    // 認証不要
  },
  component: () => (
    <div>
      <Outlet />
    </div>
  ),
});
